import React from 'react';
import { StarIcon } from 'lucide-react';
import { heroQuotes } from '../data/content';
const stats = [{
  value: '+2.500',
  label: 'familias confían'
}, {
  value: '6',
  label: 'Tomos listos'
}, {
  value: '3',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación'
}];
export function ProofBar() {
  return <section className="w-full bg-blue-50 py-14 md:py-20" data-id="element-187" data-mp="ciuf376hchr5">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-188" data-mp="3uq1q1fdwo2uh">
        <dl className="grid grid-cols-2 gap-8 text-center md:grid-cols-4" data-id="element-189" data-mp="3urv0z6vjx98a">
          {stats.map(stat => <div key={stat.label} data-id="element-190" data-mp="3h4fhe2g2cia">
              <dt className="sr-only" data-id="element-191" data-mp="3ksdvoqk7oxcu">{stat.label}</dt>
              <dd data-id="element-192" data-mp="3ktovygeg7mz7">
                <span className="block font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl" data-id="element-193" data-mp="3pqfdl85wiqmq">
                  {stat.value}
                </span>
                <span className="mt-1 block text-sm font-semibold text-blue-700" data-id="element-194" data-mp="1j10uocld79m2">{stat.label}</span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-14 grid gap-5 md:grid-cols-3" data-id="element-195" data-mp="2sdwyqlyohiz7">
          {heroQuotes.map(quote => <li key={quote.author} className="flex h-full flex-col rounded-2xl bg-white p-6 text-left shadow-soft ring-1 ring-blue-100" data-id="element-196" data-mp="2neu4lwk8kx60">
              <div className="flex items-center gap-3" data-id="element-197" data-mp="2x558jj3x76cw">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100 font-display text-xs font-bold text-blue-800" data-id="element-198" data-mp="2x6gla8fcfog5">
                  {quote.initials}
                </span>
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-199" data-mp="24jcga3g93a4d">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-200" data-mp="2ee4cb2u6pox1" data-mpi={index} />)}
                </span>
              </div>
              <p className="mt-4 text-lg leading-snug text-ink" data-id="element-201" data-mp="3pum8d1tvdpj5">“{quote.quote}”</p>
              <p className="mt-auto pt-4 text-sm font-semibold text-blue-700" data-id="element-202" data-mp="3pwp0psihvur1">
                — {quote.author}, {quote.city}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}